import { axiosInstance } from '../App';
import axios from 'axios';

export async function authenticateUser(data) {
    return axios.post('/api/auth/doAutoAuthentication', null, {
        params: {
            data: data,
            deviceId: localStorage.getItem("uuid")
        },
        headers: {
            'User-Agent': navigator.userAgent
        }
    }).then(res => {
        return res;
    }).catch(e => {
        return e;
    });
}

async function logout() {
    try {
        const res = await axiosInstance.post('/api/secured/logout', {
            deviceId: localStorage.getItem("uuid"),
        });
        return res.data;
    } catch (e) {
        return e;
    }
}

export function isAuthenticated() {
    return localStorage.getItem("login") === "true";
}

